import { Feature } from '@tencent/workbench';
import { config } from './config';
import { PlayActionFeature } from '../../titlebar/features/play-action-feature';
import { CLICK_FROM } from '../../constant';

@Feature()
export class TencentMeetingPlayFeature extends PlayActionFeature {
    id = config.id;
    config = config;
    constructor() {
        super();
    }

    public onClick() {
        this.handleClickMeetingRemotePlay(CLICK_FROM.TOOLBAR);
    }

    public shouldHide() {
        return !this.showMeetingPlay();
    }
}
